/**
 * @file index.tsx
 *
 * @fileoverview Adds blogs metatags and page title.
 */

import Head from 'next/head';
import { useMemo } from 'react';
import { OG_IMAGE_META_NAME } from '~/jobiqo/components/Metatag/MetatagDefault';

interface BlogSearchMetatagsProps {
  /**
   * The blog search results.
   */
  blogSearchResult: any;
}

export default function BlogSearchMetatags({
  blogSearchResult,
}: BlogSearchMetatagsProps) {
  const SEOShareImage = useMemo(
    () => blogSearchResult?.seoSearchContent?.shareImage,
    [blogSearchResult?.seoSearchContent?.shareImage],
  );

  return (
    <>
      <Head>
        {blogSearchResult?.metatags?.length > 0 &&
          blogSearchResult?.metatags
            .filter(({ meta }) => meta !== 'h1')
            .map(
              ({ meta, value }) =>
                meta &&
                value &&
                (meta === 'page_title' ? (
                  <title key={meta}>{value}</title>
                ) : (
                  <meta key={meta} name={meta} content={value} />
                )),
            )}
        {SEOShareImage && (
          <meta
            key={OG_IMAGE_META_NAME}
            name={OG_IMAGE_META_NAME}
            property={OG_IMAGE_META_NAME}
            content={SEOShareImage.url}
          />
        )}
      </Head>
    </>
  );
}
export { BlogSearchMetatags };
